import { CircularProgress } from "@mui/material";

import colors from "assets/theme/base/colors";
import linearGradient from "assets/theme/functions/linearGradient";
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import rgba from "assets/theme/functions/rgba";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function KpiCard({ title, value, icon, sub, color = "info", loading = false, onClick }) {
  const { black, dark, gradients, light, primary } = colors;
  const { card } = gradients;
  const { borderWidth, borderRadius } = borders;
  const { xxl } = boxShadows;

  return (
    <VuiBox
      px={2}
      py={1.5}
      borderRadius="18px"
      onClick={onClick}
      sx={{
        height: "100%",
        background: light.main,

        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",

        border: `${borderWidth[1]} solid ${rgba(black.main, 0.25)}`,

        // boxShadow: xxl,

        cursor: onClick ? "pointer" : "default",
        transition: "all 0.22s ease",

        "&:hover": onClick
          ? {
              transform: "translateY(-2px)",
              background: "rgba(255,255,255,0.07)",
              border: "1px solid rgba(255,255,255,0.14)",
              boxShadow: "0 10px 24px rgba(0,0,0,0.22)",
            }
          : {},

        "&:active": onClick
          ? {
              transform: "scale(0.985)",
            }
          : {},
      }}
    >
      <VuiBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <VuiTypography
          variant="caption"
          sx={{
            fontSize: "11px",
          }}
        >
          {title}
        </VuiTypography>

        <VuiBox
          sx={{
            width: 34,
            height: 34,
            borderRadius: "8px",
            // background: light.secondary,
            border: `1px solid ${rgba(dark.main, 0.25)}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: primary.main,
          }}
        >
          {icon}
        </VuiBox>
      </VuiBox>

      <VuiBox display="flex" alignItems="flex-end" gap={1}>
        {loading ? (
          <CircularProgress
            size={20}
            thickness={4}
            sx={{
              color: primary.main,
            }}
          />
        ) : (
          <VuiTypography
            variant="h4"
            fontWeight="medium"
            lineHeight={1}
            sx={{
              maxWidth: "100%",
              overflowWrap: "break-word",
              wordBreak: "break-word",
            }}
          >
            {value}
          </VuiTypography>
        )}

        {!!sub && (
          <VuiTypography color={color} variant="caption" fontWeight="regular" mb="3px">
            {sub}
          </VuiTypography>
        )}
      </VuiBox>
    </VuiBox>
  );
}

export default KpiCard;
